import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = 'white'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: 'black',
        alignItems: 'center',
        height: 15,
        fontFamily:'Calibri Regular',
        fontSize:7,
        color:'white',
        textAlign: 'center',
        flexGrow: 1,

    },
    password: {
        width: '50%',
        borderLeftColor: borderColor,
        borderLeftWidth: 0.5,
        fontSize:8,
        paddingTop:2
    },
    id: {
        width: '100%',
        fontSize:9,
        paddingTop:3,
        height:"100%",
        borderWidth:1,
        borderColor:"white",
    },

  });

  const Comments = ({date}) => (
    <View style={styles.container}>
        <Text style={styles.id}>Comments</Text>
  </View>
  );
  
  export default Comments